export default __webpack_public_path__ + "static/media/Icon awesome-handshake.a8a0ca69.svg";